<x-shop-dialog heading="Failed to add address" [canClose]="false">
  <div xIcon class="icon-status fail">
    <fa-icon icon="times"></fa-icon>
  </div>

  <ng-container i18n="@@AddressRegion.NoMatch.Note">
    The address you are trying to add is not supported by your current channel.
  </ng-container>

  <x-shop-dialog-actions>
    <button
      xAction
      mat-flat-button
      color="primary"
      (click)="closeDialog()"
      i18n="@@CallToAction.TryAddAnotherAddress"
    >
      Try to add another address
    </button>
  </x-shop-dialog-actions>
</x-shop-dialog>
